var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["header/utility-currency-image.j2"] = require( "header/utility-currency-image.j2" );
dependencies["header/utility-currency-label.j2"] = require( "header/utility-currency-label.j2" );
dependencies["./utility-dropdown-asset.j2"] = require( "./utility-dropdown-asset.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/utility-currency.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"header")),"availableCurrencies")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteId"))),"currencies")) > 1 || env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"header")),"availableSites")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteId"))),"languages")) > 1) {
output += "\n\n";
var t_1;
t_1 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"currency");
frame.set("selectedCurrency", t_1, true);
if(frame.topLevel) {
context.setVariable("selectedCurrency", t_1);
}
if(frame.topLevel) {
context.addExport("selectedCurrency", t_1);
}
output += "\n";
var t_2;
t_2 = (lineno = 3, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["language-name-" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"language"),runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})]));
frame.set("selectedDisplayLanguage", t_2, true);
if(frame.topLevel) {
context.setVariable("selectedDisplayLanguage", t_2);
}
if(frame.topLevel) {
context.addExport("selectedDisplayLanguage", t_2);
}
output += "\n\n    <li class=\"c-utility__li c-utility__currency dom-utility-currency\">\n        <div class=\"js-dropdown-toggle-hover\" data-dropdown-toggle=\"utility-currency\">\n            <div class=\"c-utility-toggle-outer js-dropdown-container\" role=\"menubar\" data-qa-language-toggle=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "selectedDisplayLanguage"), env.opts.autoescape);
output += "\">\n\n                <div class=\"c-utility-toggle__title--outer\">\n\n                    <a class=\"u-extra-small--hide u-large--show c-utility__a c-utility-toggle__title js-currency-toggle\" href=\"#\" aria-label=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "selectedCurrency"), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "selectedDisplayLanguage"), env.opts.autoescape);
output += "\" role=\"menuitem\">\n\n                        ";
env.getTemplate("header/utility-currency-image.j2", false, "core/templates/header/utility-currency.j2", null, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
t_3.render(context.getVariables(), frame, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
output += t_4
output += "\n\n                        ";
env.getTemplate("header/utility-currency-label.j2", false, "core/templates/header/utility-currency.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n\n                    </a>\n\n                    <span class=\"c-utility__a c-utility__span c-utility__span--currency c-utility-toggle__title c-utility-toggle__title--hide js-dropdown-toggle\" role=\"menuitem\" data-qa-language-toggle-dropdown>\n\n                        ";
env.getTemplate("header/utility-currency-image.j2", false, "core/templates/header/utility-currency.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "\n\n                        ";
env.getTemplate("header/utility-currency-label.j2", false, "core/templates/header/utility-currency.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
output += t_16
output += "\n\n                    </span>\n\n                    ";
env.getTemplate("./utility-dropdown-asset.j2", false, "core/templates/header/utility-currency.j2", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
output += t_20
output += "\n\n\n                </div>\n\n                <div class=\"c-utility-toggle-inner c-utility-toggle-inner--two-column u-clearfix\" role=\"menu\">\n\n                <div class=\"c-utility-toggle__ul c-utility-toggle__ul--currency c-utility-toggle__ul--two-column\">\n                    <h3 class=\"c-utility-toggle__h3\">\n                        ";
output += runtime.suppressValue((lineno = 36, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["currency-label",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                    </h3>\n\n                    <ul class=\"c-utility-toggle__ul\">\n\n                        ";
frame = frame.push();
var t_25 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"header")),"availableCurrencies")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteId"))),"currencies");
if(t_25) {var t_24 = t_25.length;
for(var t_23=0; t_23 < t_25.length; t_23++) {
var t_26 = t_25[t_23];
frame.set("currency", t_26);
frame.set("loop.index", t_23 + 1);
frame.set("loop.index0", t_23);
frame.set("loop.revindex", t_24 - t_23);
frame.set("loop.revindex0", t_24 - t_23 - 1);
frame.set("loop.first", t_23 === 0);
frame.set("loop.last", t_23 === t_24 - 1);
frame.set("loop.length", t_24);
output += "\n\n                        <li class=\"c-utility-toggle__li c-utility__currency--li\" role=\"menuitem\">\n                            <a class=\"c-utility-toggle__a c-utility__currency--a js-site-currency-change ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "selectedCurrency") == runtime.memberLookup((t_26),"currencyCode")?"c-utility-toggle__a--current":""), env.opts.autoescape);
output += "\" href=\"#\" data-js-currency=\"";
output += runtime.suppressValue(runtime.memberLookup((t_26),"currencyCode"), env.opts.autoescape);
output += "\" aria-label=\"Currency options\"\n                            ";
output += runtime.suppressValue((lineno = 45, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey"),"currency set",runtime.contextOrFrameLookup(context, frame, "selectedCurrency") + "" + "|" + "" + runtime.memberLookup((t_26),"currencyCode")])), env.opts.autoescape);
output += ">\n                                ";
output += runtime.suppressValue(runtime.memberLookup((t_26),"currencyCode"), env.opts.autoescape);
output += "\n                            </a>\n                        </li>\n\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </ul>\n\n                </div>\n\n                <div class=\"c-utility-toggle__ul c-utility-toggle__ul--language c-utility-toggle__ul--two-column\">\n\n                    <h3 class=\"c-utility-toggle__h3\">\n                        ";
output += runtime.suppressValue((lineno = 58, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["language-label",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                    </h3>\n\n                    <ul class=\"c-utility-toggle__ul\">\n\n                        ";
frame = frame.push();
var t_29 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"header")),"availableSites")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteId"))),"languages");
if(t_29) {var t_28 = t_29.length;
for(var t_27=0; t_27 < t_29.length; t_27++) {
var t_30 = t_29[t_27];
frame.set("language", t_30);
frame.set("loop.index", t_27 + 1);
frame.set("loop.index0", t_27);
frame.set("loop.revindex", t_28 - t_27);
frame.set("loop.revindex0", t_28 - t_27 - 1);
frame.set("loop.first", t_27 === 0);
frame.set("loop.last", t_27 === t_28 - 1);
frame.set("loop.length", t_28);
output += "\n\n                        <li class=\"c-utility-toggle__li c-utility__currency--li\" role=\"menuitem\">\n                            <a class=\"c-utility-toggle__a c-utility__currency--a js-site-language-change ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"language") == runtime.memberLookup((t_30),"locale")?"c-utility-toggle__a--current":""), env.opts.autoescape);
output += "\" href=\"#\" data-js-locale=\"";
output += runtime.suppressValue(runtime.memberLookup((t_30),"locale"), env.opts.autoescape);
output += "\" data-qa-language-option=\"";
output += runtime.suppressValue(runtime.memberLookup((t_30),"locale"), env.opts.autoescape);
output += "\"\n                            ";
output += runtime.suppressValue((lineno = 67, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey"),"language set",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"language") + "" + "|" + "" + runtime.memberLookup((t_30),"locale")])), env.opts.autoescape);
output += ">\n                                ";
output += runtime.suppressValue((lineno = 68, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["language-name-" + "" + runtime.memberLookup((t_30),"locale"),runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                            </a>\n                        </li>\n\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </ul>\n\n                </div>\n\n            </div>\n        </div>\n\n    </li>\n\n";
})})})})})})})})})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/utility-currency.j2"] , dependencies)